var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRiskLevelRect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Risk Level Rect",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 20
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 328",
    width: 12,
    height: 20,
    rx: 4,
    fill: "#000450"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iUmlza19MZXZlbF9SZWN0IiBkYXRhLW5hbWU9IlJpc2sgTGV2ZWwgUmVjdCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMTIiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAxMiAyMCI+CiAgPHJlY3QgaWQ9IlJlY3RhbmdsZV8zMjgiIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDMyOCIgd2lkdGg9IjEyIiBoZWlnaHQ9IjIwIiByeD0iNCIgZmlsbD0iIzAwMDQ1MCIvPgo8L3N2Zz4K";
export { SvgRiskLevelRect as ReactComponent };